import { render, staticRenderFns } from "./RiskPill.vue?vue&type=template&id=10d63984&scoped=true&"
import script from "./RiskPill.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RiskPill.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RiskPill.vue?vue&type=style&index=0&id=10d63984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d63984",
  null
  
)

export default component.exports